<template>
  <CommonArticle
    :content-id="article.contentId"
    :titles="article.titles"
    :publicationDate="publicationDate"
  >
  </CommonArticle>
</template>

<script>
import CommonArticle from '@/components/articles/CommonArticle.vue'
import { getArticleByContentId } from '@/data/articles'

export default {
  name: 'NachhaltigerGrundriss',
  components: {
    CommonArticle
  },
  setup() {
    const article = getArticleByContentId('sustainable-floorplan')
    return {
      article,
      publicationDate: new Date(article.publicationDate)
    }
  }
}
</script>
